import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import WorkflowCard from "./WorkflowCard";

export default function WebAnalyticsFirstpartyWorkflow() {
    const data = useStaticQuery(graphql`
    query WebAnalyticsFirstpartyWorkflowQuery {
      recipe(enabled: {eq: true}, slug: {eq: "firstparty-web-analytics"}) {
        content
        description
        name
        total_steps
        slug
        steps {
          object
        }
      }
    }
  `)

    const recipe = data.recipe;

    return (
        <WorkflowCard recipe={recipe} />
    )
}